import React from 'react';
import DataTable from '../common/DataTable';
import StatusBadge from '../common/StatusBadge';
import { formatCurrency, formatDate } from '../../utils/formatters';
import './BillingHistory.css';

const BillingHistory = ({ history }) => {
  const cols = [
    { header: 'Date', accessor: 'date', render: (row) => formatDate(row.date) },
    { header: 'Description', accessor: 'description' },
    { header: 'Type', accessor: 'type' },
    { header: 'Amount (ZAR)', accessor: 'amount', render: (row) => formatCurrency(row.amount) },
    { header: 'Status', accessor: 'status', render: (row) => <StatusBadge status={row.status} /> }
  ];

  return (
    <div className="billing-history card">
      <div className="card-header flex-between">
        <h2>Billing History</h2>
        <button className="btn-secondary">Export CSV</button>
      </div>
      <div className="card-body">
        <DataTable columns={cols} data={history} emptyMessage="No billing records found." />
      </div>
    </div>
  );
};
export default BillingHistory;
